import React from 'react';
import colors from 'constants/colors';
import { Statistic, Card, Row, Col, Spin } from 'antd';
import { useGetBugFeatureStatistics } from 'query/admin';

export default function BugFeatureStatistics() {
  const { data, isLoading } = useGetBugFeatureStatistics();
  return (
    <Spin spinning={isLoading}>
      <Row gutter={16}>
        <Col span={8}>
          <Card>
            <Statistic
              precision={0}
              suffix="bugs"
              title="Reported Bugs"
              value={`${data.totalTodoBugs || 0} / ${data.totalInProgressBugs ||
                0}`}
              valueStyle={{ color: colors.ERROR }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              suffix="features"
              title="Feature Requests"
              value={`${data.totalTodoFeatures ||
                0} / ${data.totalInProgressFeatures || 0}`}
              valueStyle={{ color: colors.PRIMARY }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              suffix="closed"
              title="Closed"
              value={
                (data.totalClosedBugs || 0) + (data.totalClosedFeatures || 0)
              }
              valueStyle={{ color: colors.SUCCESS }}
            />
          </Card>
        </Col>
      </Row>
    </Spin>
  );
}
